import React, { Component } from "react";
import { connect } from "react-redux";
import Info from "../shared/Info";
import {
  addFeedbacks,
  getMemberFeks,
  selectWorkflow,
  clearMemberFek,
  getMemberIbans,
  clearMemberIban,

} from "../../../state/ducks/workflow/index";
import $ from "jquery";
import { getKvkkService } from "../../../services/common.service";
import KvkkModal from "../shared/KvkkModal";

function oneriFormKontrol() {
  var konu = $("#konu").val();
  var mesaj = $("#mesaj").val();
  var selectTalep = $("#talep option:selected").text();
  var selectUyeNo = $("#uyeNo option:selected").text();

  var selectUyeNoIban = $("#uyeNoIban option:selected").text();
  var selectedSaticiTuru = $("#saticiTuru option:selected").text();

  var adiSoyadi = $("#adiSoyadi").val();
  var tckn = $("#tckn").val();
  var babaAdi = $("#babaAdi").val();

  var unvan = $("#unvan").val();
  var vkn = $("#vkn").val();
  var mersisNo = $("#mersisNo").val();

  var iban = $("#iban").val();
  var phone = $("#phone").val();

  var durum = 1;

  // anlık kontrol için - checkbox
  document.querySelector('#onaychecked').addEventListener("change", function () {
    if ($("#onaychecked").is(':checked')) {
      $(".t-tooltip").css({ "display": "none" });
    } else {
      $(".t-tooltip").css({ "display": "flex" });
    }
  });

  // checkbox kontrol
  if ($("#onaychecked").is(':checked')) {
    $(".t-tooltip").css({ "display": "none" });
  } else {
    durum = 0; // Seçili değil
    $(".t-tooltip").css({ "display": "flex" });
  }
  // konu boş mu kontrol
  if (selectTalep == "Seçiniz") {
    durum = 0; // Konu Boş
    $("#talep").parent().addClass("t-error");
    $("#talep").next().html("<i class='t-icon-error text-danger'></i>");
    $("#talep_hatamesaj").html("Başvuru nedeni boş bırakılamaz");
  } else {
    $("#talep").parent().removeClass("t-error");
    $("#talep").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#talep_hatamesaj").html("");
  }

  if (selectUyeNo == "Seçiniz" && (selectTalep == "Araç Rehin Fek" || selectTalep == "Konut İpotek Fek")) {
    durum = 0; // Konu Boş
    $("#uyeNo").parent().addClass("t-error");
    $("#uyeNo").next().html("<i class='t-icon-error text-danger'></i>");
    $("#talep_hatamesaj").html("Uyelik bilgisi boş bırakılamaz");
  } else {
    $("#uyeNo").parent().removeClass("t-error");
    $("#uyeNo").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#talep_hatamesaj").html("");
  }

  if (selectTalep == "Satıcı IBAN Girişi") {

    if (selectedSaticiTuru == "Seçiniz") {
      durum = 0; // Konu Boş
      $("#saticiTuru").parent().addClass("t-error");
      $("#saticiTuru").next().html("<i class='t-icon-error text-danger'></i>");
      $("#saticiTuru_hatamesaj").html("Satıcı Türü boş bırakılamaz");
    } else {
      $("#saticiTuru").parent().removeClass("t-error");
      $("#saticiTuru").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#saticiTuru_hatamesaj").html("");
    }

    if (selectUyeNoIban == "Seçiniz") {
      durum = 0; // Konu Boş
      $("#uyeNoIban").parent().addClass("t-error");
      $("#uyeNoIban").next().html("<i class='t-icon-error text-danger'></i>");
      $("#uyeNoIban_hatamesaj").html("Uyelik bilgisi boş bırakılamaz");
    } else {
      $("#uyeNoIban").parent().removeClass("t-error");
      $("#uyeNoIban").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#uyeNoIban_hatamesaj").html("");
    }

    if (selectedSaticiTuru == "Bireysel") {


      if (adiSoyadi == "") {
        durum = 0; // Konu Boş
        $("#adiSoyadi").parent().addClass("t-error");
        $("#adiSoyadi").next().html("<i class='t-icon-error text-danger'></i>");
        $("#adiSoyadi_hatamesaj").html("Satıcı Adı Soyadı alanı boş bırakılamaz");
      } else {
        $("#adiSoyadi").parent().removeClass("t-error");
        $("#adiSoyadi").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#adiSoyadi_hatamesaj").html("");
      }


      if (tckn == "") {
        durum = 0; // Konu Boş
        $("#tckn").parent().addClass("t-error");
        $("#tckn").next().html("<i class='t-icon-error text-danger'></i>");
        $("#tckn_hatamesaj").html("Satıcı TCKN alanı boş bırakılamaz");
      } else {
        $("#tckn").parent().removeClass("t-error");
        $("#tckn").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#tckn_hatamesaj").html("");
      }

      if (babaAdi == "") {
        durum = 0; // Konu Boş
        $("#babaAdi").parent().addClass("t-error");
        $("#babaAdi").next().html("<i class='t-icon-error text-danger'></i>");
        $("#babaAdi_hatamesaj").html("Satıcı Baba Adı alanı boş bırakılamaz");
      } else {
        $("#babaAdi").parent().removeClass("t-error");
        $("#babaAdi").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#babaAdi_hatamesaj").html("");
      }
    }

    if (selectedSaticiTuru == "Kurumsal") {



      if (unvan == "") {
        durum = 0; // Konu Boş
        $("#unvan").parent().addClass("t-error");
        $("#unvan").next().html("<i class='t-icon-error text-danger'></i>");
        $("#unvan_hatamesaj").html("Satıcı Ünvan alanı boş bırakılamaz");
      } else {
        $("#unvan").parent().removeClass("t-error");
        $("#unvan").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#unvan_hatamesaj").html("");
      }


      if (vkn == "") {
        durum = 0; // Konu Boş
        $("#vkn").parent().addClass("t-error");
        $("#vkn").next().html("<i class='t-icon-error text-danger'></i>");
        $("#vkn_hatamesaj").html("Satıcı VKN alanı boş bırakılamaz");
      } else {
        $("#vkn").parent().removeClass("t-error");
        $("#vkn").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#vkn_hatamesaj").html("");
      }
    }

    if (phone == "") {
      durum = 0; // Konu Boş
      $("#phone").parent().addClass("t-error");
      $("#phone").next().html("<i class='t-icon-error text-danger'></i>");
      $("#phone_hatamesaj").html("Satıcı Telefon Numarası alanı boş bırakılamaz");
    } else {
      $("#phone").parent().removeClass("t-error");
      $("#phone").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#phone_hatamesaj").html("");
    }

    iban = iban.replace(/\s/g, "");
    const ibanRegex = /^TR[0-9]{24}$/;
    if (!ibanRegex.test(iban)) {
      durum = 0; // Konu Boş
      $("#iban").parent().addClass("t-error");
      $("#iban").next().html("<i class='t-icon-error text-danger'></i>");
      $("#iban_hatamesaj").html("Satıcı IBAN alanını geçerli bir değer giriniz");
    } else if (iban == "") {
      durum = 0; // Konu Boş
      $("#iban").parent().addClass("t-error");
      $("#iban").next().html("<i class='t-icon-error text-danger'></i>");
      $("#iban_hatamesaj").html("Satıcı IBAN alanı boş bırakılamaz");
    } else {
      $("#iban").parent().removeClass("t-error");
      $("#iban").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#iban_hatamesaj").html("");
    }

  } else {

  }

  // konu boş mu kontrol
  if (konu == "") {
    durum = 0; // Konu Boş
    $("#konu").parent().addClass("t-error");
    $("#konu").next().html("<i class='t-icon-error text-danger'></i>");
    $("#konu_hatamesaj").html("Konu alanı boş bırakılamaz");
  } else {
    $("#konu").parent().removeClass("t-error");
    $("#konu").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#konu_hatamesaj").html("");
  }
  // Açıklama boş mu kontrol
  if (mesaj == "" && selectTalep != "Satıcı IBAN Girişi") {
    durum = 0; // Mesaj Boş
    $("#mesaj").parent().addClass("t-error");
    $("#mesaj").next().html("<i class='t-icon-error text-danger'></i>");
    $("#mesaj_hatamesaj").html("Mesaj alanı boş bırakılamaz");
  } else {
    $("#mesaj").parent().removeClass("t-error");
    $("#mesaj").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
    $("#mesaj_hatamesaj").html("");
  };
  return durum;
}

export class SubmitDemand extends Component {
  state = {
    subject: "",
    description: "",
    reason: "0",
    memberNo: "0",
    memberFekList: [],
    isSubjectReadonly: true,
    kvkkMetni: "",
    isKvkkModalOpen: false,
    memberIbanList: [],

    nameSurname: "",
    tckn: "",
    fatherName: "",

    unvan: "",
    vkn: "",
    mersisNo: "",

    iban: "",
    phone: "",

    saticiTuru: "0",
  };
  componentDidMount() {
    this.setState({ memberNo: "0" });
    this.props.clearMemberFek();
    this.props.clearMemberIban();
    this.setState({ saticiTuru: "0" });
  }
  onSubmit = (e) => {
    e.preventDefault();

    if (oneriFormKontrol() == 0) {
      return false;
    }
    this.props.addFeedbacks(
      this.state.subject,
      this.state.description,
      this.state.reason,
      this.state.memberNo,

      this.state.nameSurname,
      this.state.tckn,
      this.state.fatherName,

      this.state.unvan,
      this.state.vkn,
      this.state.mersisNo,

      this.state.iban,
      this.state.phone,
    );
  };
  componentDidUpdate(prevProps) {
    // MemberFek kontrolün (bunu değiştirmedik)
    if (
      (this.state.reason === "5" || this.state.reason === "6") &&
      !this.props.isLoading
    ) {
      if (this.props.memberFekList.length === 0 && !this.props.isLoading) {
        $("#uyeNo").parent().addClass("t-error");
        $("#uyeNo").next().html("<i class='t-icon-error text-danger'></i>");
        $("#talep_hatamesaj").html(
          "Üyelik bulunamadı. Araç Rehin Fek ya da Konut İpotek Fek talebi açılamaz."
        );
      } else {
        $("#uyeNo").parent().removeClass("t-error");
        $("#uyeNo").next().html(
          "<i class='t-icon-check_circle_outline text-success'></i>"
        );
        $("#talep_hatamesaj").html("");
      }
    }

    if (
      (this.state.reason === "7") &&
      !this.props.isLoading
    ) {
      if (this.props.memberIbanList.length === 0 && !this.props.isLoading) {
        $("#uyeNoIban").parent().addClass("t-error");
        $("#uyeNoIban").next().html("<i class='t-icon-error text-danger'></i>");
        $("#talep_hatamesaj").html(
          "Üyelik bulunamadı. Satıcı IBAN Girişi talebi açılamaz."
        );
      } else {
        $("#uyeNoIban").parent().removeClass("t-error");
        $("#uyeNoIban").next().html(
          "<i class='t-icon-check_circle_outline text-success'></i>"
        );
        $("#talep_hatamesaj").html("");
      }
    }

    // ❗ Form resetleme sadece error yeni geldiyse yapılmalı
    if (
      this.props.workflow?.error &&
      prevProps.workflow?.error !== this.props.workflow.error
    ) {
      this.setState({
        subject: "",
        description: "",
        reason: "0",
        memberNo: "0",
        isSubjectReadonly: true,

        nameSurname: "",
        tckn: "",
        fatherName: "",

        unvan: "",
        vkn: "",
        mersisNo: "",

        iban: "",
        phone: "",

        saticiTuru: "0",
      });
      this.props.clearMemberFek();
      this.props.clearMemberIban();
      $("#talep").val("0");
      $("#konu").val("");
      $("#mesaj").val("");
      $("#uyeNo").val("");
      $("#onaychecked").prop("checked", false);
      $("#talep_hatamesaj").html("");
    }
  }

  getKvkk = () => {
    getKvkkService().then(
      (response) => {
        console.log(response);
        this.setState({
          isKvkkModalOpen: true,
          kvkkMetni: response.data?.kvkkMetni ?? "", // KVKK metnini de set et
        });
      },
      (error) => {
        console.error("KVKK metni alınamadı", error);
      }
    );
  };

  closeKvkkModal = () => {
    this.setState({ isKvkkModalOpen: false });
  };

  render() {
    const { workflow } = this.props;
    if (workflow?.addedFeedback) {
      return (
        <Info
          header={"Talebiniz alınmıştır."}
          body={
            "Talebiniz ile ilgili gelişmeleri 'Talep Takibi' menüsünden takip edebilirsiniz."
          }
        ></Info>
      );
    } else {
      return (
        <div className="container-fluid">
          {/* yesil Alan*/}
          <div className="row" style={{ padding: "3%" }}>
            <div className="col-12">
              {/* KUTU 1 */}
              <div className="row no-gutters t-kutu t-yesilCizgi">
                <div
                  className="col bosluk backright"
                  style={{
                    backgroundImage: 'url("/assets/img/backgrounds/back_right_yesil.jpg")'
                  }}
                >
                  {/* içerikler */}
                  {/* Başlık */}
                  <div className="row no-gutters pb-4">
                    <div clss="col-auto">
                      <i className="t-icon-bubble1 icon" />
                    </div>
                    <div className="col d-flex flex-column justify-content-center">
                      <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                        Öneri ve İstekleriniz
                      </div>
                      <span className="altBaslik">Öneri ve İstek Bildirimi</span>
                    </div>
                  </div>
                  <div className="row no-gutters">
                    <div className="col-12 pb-1">
                      <span className="t-icInputTitle pl-3">Başvuru Nedeniniz</span>
                    </div>
                    {/* üye numaranız*/}
                    <div className="col-12">
                      <div className="t-icInput">
                        <div>
                          <i className="t-icon-lock1" />
                        </div>
                        <select
                          className="custom-select"
                          id="talep"
                          onChange={(e) => {
                            const value = e.target.value;
                            const selectTalep = $("#talep option:selected").text();
                            this.setState({ reason: value });
                            this.setState({ saticiTuru: "0" });

                            if (value === "5" || value === "6") {
                              this.setState({ memberNo: "0", subject: selectTalep, isSubjectReadonly: true });
                              this.props.getMemberFeks(value);
                            }
                            if (value === "7") {
                              this.setState({ memberNo: "0", subject: selectTalep, isSubjectReadonly: true });
                              this.props.getMemberIbans(value);
                            }
                            else {
                              $("#uyeNo").parent().removeClass("t-error");
                              $("#uyeNo").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
                              $("#talep_hatamesaj").html("");
                              this.setState({ memberNo: "0", subject: "", isSubjectReadonly: false });
                              this.props.clearMemberFek();
                              this.props.clearMemberIban();
                            }
                          }}
                        >
                          <option value="0">Seçiniz</option>
                          <option value="1">Şikayet</option>
                          <option value="2">Talep</option>
                          <option value="3">Öneri</option>
                          <option value="4">Memnuniyet</option>
                          <option value="5">Araç Rehin Fek</option>
                          <option value="6">Konut İpotek Fek</option>
                          <option value="7">Satıcı IBAN Girişi</option>
                        </select>
                        <div />
                      </div>
                    </div>
                    {/* Hata mesajının geleceği alan*/}
                    <div
                      className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                      id="talep_hatamesaj"
                    />
                    {(this.props.memberFekList && this.props.memberFekList.length > 0) && (
                      <div className="col-12 pb-1">
                        <span className="t-icInputTitle pl-3">Üyelik Bilgisi</span>
                        <div className="t-icInput">
                          <div>
                            <i className="t-icon-user" />
                          </div>
                          <select
                            className="custom-select"
                            id="uyeNo"
                            onChange={(e) => this.setState({ memberNo: e.target.value })}
                          >
                            <option value="">Seçiniz</option>
                            {this.props.memberFekList.map((item, index) => (
                              <option key={item.id} value={item.id}>
                                {item.adi}
                              </option>
                            ))}
                          </select>
                          <div />
                        </div>
                      </div>

                    )}

                    {/* Konu */}
                    <div className="col-12 pb-1">
                      <span className="t-icInputTitle pl-3">Konu</span>
                    </div>
                    <div className="col-12">
                      <div className="t-icInput">
                        <div>
                          <i className="t-icon-pen1" />
                        </div>
                        <input
                          type="text"
                          id="konu"
                          name="konu"
                          placeholder="Konu Başlığınızı Yazınız"
                          required
                          maxLength="200"
                          value={this.state.subject}
                          readOnly={this.state.isSubjectReadonly}
                          onChange={(e) => {
                            this.setState({ subject: e.target.value });
                          }}
                        />
                        <div />
                      </div>
                    </div>
                    {/* KONU Hata mesajının geleceği alan*/}
                    <div
                      className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                      id="konu_hatamesaj"
                    />






                    {(this.state.reason === "7") && (
                      <div className="col-12 pb-1">


                        <div className="">
                          <span className="t-icInputTitle pl-3">Üyelik Bilgisi</span>
                          <div className="t-icInput">
                            <div>
                              <i className="t-icon-user" />
                            </div>
                            <select
                              className="custom-select"
                              id="uyeNoIban"
                              onChange={(e) => this.setState({ memberNo: e.target.value })}
                            >
                              <option value="">Seçiniz</option>
                              {this.props.memberIbanList.map((item, index) => (
                                <option key={item.id} value={item.id}>
                                  {item.adi}
                                </option>
                              ))}
                            </select>
                            <div />
                          </div>
                        </div>
                        {/* UyeNo Hata mesajının geleceği alan*/}
                        <div
                          className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                          id="uyeNoIban_hatamesaj"
                        />





                        <div className="">
                          <span className="t-icInputTitle pl-3">Satıcı Türü</span>
                        </div>
                        {/* Satıcı Turu*/}
                        <div className="col-12 p-0">
                          <div className="t-icInput">
                            <div>
                              <i className="t-icon-lock1" />
                            </div>
                            <select
                              className="custom-select"
                              id="saticiTuru"
                              onChange={(e) => {
                                const value = e.target.value;
                                this.setState({ saticiTuru: value });
                              }}
                            >
                              <option value="0">Seçiniz</option>
                              <option value="1">Bireysel</option>
                              <option value="2">Kurumsal</option>
                            </select>
                            <div />
                          </div>
                        </div>
                        {/* Hata mesajının geleceği alan*/}
                        <div
                          className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                          id="saticiTuru_hatamesaj"
                        />


                        {/* BİREYSEL */}
                        {(this.state.saticiTuru === "1") && (
                          <div>

                            {/* Adı Soyadı*/}
                            <div className="">
                              <span className="t-icInputTitle pl-3">Satıcı Adı Soyadı</span>
                            </div>
                            <div className="">
                              <div className="t-icInput">
                                <div>
                                  <i className="t-icon-pen1" />
                                </div>
                                <input
                                  type="text"
                                  id="adiSoyadi"
                                  name="adiSoyadi"
                                  placeholder="Satıcı Adı Soyadı Yazınız"
                                  required
                                  maxLength="200"
                                  value={this.state.nameSurname}
                                  onChange={(e) => {
                                    this.setState({ nameSurname: e.target.value });
                                  }}
                                />
                                <div />
                              </div>
                            </div>
                            {/* Baba Adı Hata mesajının geleceği alan*/}
                            <div
                              className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                              id="adiSoyadi_hatamesaj"
                            />

                            {/* TCKN*/}
                            <div className="">
                              <span className="t-icInputTitle pl-3">Satıcı TC Kimlik No</span>
                            </div>
                            <div className="">
                              <div className="t-icInput">
                                <div>
                                  <i className="t-icon-pen1" />
                                </div>
                                <input
                                  type="text"
                                  id="tckn"
                                  name="tckn"
                                  placeholder="Satıcı TC Kimlik No Yazınız"
                                  required
                                  maxLength="11"
                                  value={this.state.tckn}
                                  onChange={(e) => {
                                    const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                                    this.setState({ tckn: onlyNumbers });
                                  }}
                                />
                                <div />
                              </div>
                            </div>
                            {/* TCKAN Hata mesajının geleceği alan*/}
                            <div
                              className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                              id="tckn_hatamesaj"
                            />





                            {/* Baba Adı */}
                            <div className="">
                              <span className="t-icInputTitle pl-3">Satıcı Baba Adı</span>
                            </div>
                            <div className="">
                              <div className="t-icInput">
                                <div>
                                  <i className="t-icon-pen1" />
                                </div>
                                <input
                                  type="text"
                                  id="babaAdi"
                                  name="babaAdi"
                                  placeholder="Satıcı Baba Adını Yazınız"
                                  required
                                  maxLength="200"
                                  value={this.state.fatherName}
                                  onChange={(e) => {
                                    this.setState({ fatherName: e.target.value });
                                  }}
                                />
                                <div />
                              </div>
                            </div>
                            {/* Baba Adı Hata mesajının geleceği alan*/}
                            <div
                              className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                              id="babaAdi_hatamesaj"
                            />


                          </div>

                        )}


                        {/* KURUMSAL */}
                        {(this.state.saticiTuru === "2") && (
                          <div>

                            {/* Ünvan*/}
                            <div className="">
                              <span className="t-icInputTitle pl-3">Satıcı Ünvan</span>
                            </div>
                            <div className="">
                              <div className="t-icInput">
                                <div>
                                  <i className="t-icon-pen1" />
                                </div>
                                <input
                                  type="text"
                                  id="unvan"
                                  name="unvan"
                                  placeholder="Satıcı Ünvanı Yazınız"
                                  required
                                  maxLength="500"
                                  value={this.state.unvan}
                                  onChange={(e) => {
                                    this.setState({ unvan: e.target.value });
                                  }}
                                />
                                <div />
                              </div>
                            </div>
                            {/* Ünvan Hata mesajının geleceği alan*/}
                            <div
                              className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                              id="unvan_hatamesaj"
                            />

                            {/* VKN*/}
                            <div className="">
                              <span className="t-icInputTitle pl-3">Satıcı VKN</span>
                            </div>
                            <div className="">
                              <div className="t-icInput">
                                <div>
                                  <i className="t-icon-pen1" />
                                </div>
                                <input
                                  type="text"
                                  id="vkn"
                                  name="vkn"
                                  placeholder="Satıcı VKN Yazınız"
                                  required
                                  maxLength="10"
                                  value={this.state.vkn}
                                  onChange={(e) => {

                                    const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                                    this.setState({ vkn: onlyNumbers });
                                  }}
                                />
                                <div />
                              </div>
                            </div>
                            {/* VKN Hata mesajının geleceği alan*/}
                            <div
                              className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                              id="vkn_hatamesaj"
                            />





                            {/* Mersis No */}
                            <div className="">
                              <span className="t-icInputTitle pl-3">Satıcı Mersis No</span>
                            </div>
                            <div className="">
                              <div className="t-icInput">
                                <div>
                                  <i className="t-icon-pen1" />
                                </div>
                                <input
                                  type="text"
                                  id="mersisNo"
                                  name="mersisNo"
                                  placeholder="Satıcı Mersis No Yazınız"
                                  required
                                  maxLength="16"
                                  value={this.state.mersisNo}
                                  onChange={(e) => {
                                    this.setState({ mersisNo: e.target.value });
                                  }}
                                />
                                <div />
                              </div>
                            </div>
                            {/* Mersis No Hata mesajının geleceği alan*/}
                            <div
                              className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                              id="mersisNo_hatamesaj"
                            />


                          </div>

                        )}

                        {/* BİREYSEL/KURUMSAL */}
                        {(this.state.saticiTuru === "1" || this.state.saticiTuru === "2") && (
                          <div>

                            {/* SATICI TELEFON */}
                            <div className="">
                              <span className="t-icInputTitle pl-3">Satıcı Tel No</span>
                            </div>
                            <div className="">
                              <div className="t-icInput">
                                <div>
                                  <i className="t-icon-pen1" />
                                </div>
                                <input
                                  type="text"
                                  id="phone"
                                  name="phone"
                                  placeholder="Satıcı Tel No"
                                  required
                                  maxLength="10"
                                  value={this.state.phone}
                                  onChange={(e) => {

                                    const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
                                    this.setState({ phone: onlyNumbers });
                                  }}
                                />
                                <div />
                              </div>
                            </div>
                            {/* TEL NO Hata mesajının geleceği alan*/}
                            <div
                              className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                              id="phone_hatamesaj"
                            />

                            {/* IBAN */}
                            <div className="">
                              <span className="t-icInputTitle pl-3">Satıcı IBAN</span>
                            </div>
                            <div className="">
                              <div className="t-icInput">
                                <div>
                                  <i className="t-icon-pen1" />
                                </div>
                                <input
                                  type="text"
                                  id="iban"
                                  name="iban"
                                  placeholder="TR ---- ---- ---- ---- ---- ----"
                                  required
                                  maxLength="32"
                                  value={this.state.iban}
                                  onChange={(e) => {
                                    let raw = e.target.value.toUpperCase();

                                    // Baştaki TR’yi temizle (sonra biz ekleyeceğiz)
                                    raw = raw.replace(/^TR?/, "");

                                    // Sadece rakam bırak
                                    raw = raw.replace(/[^0-9]/g, "");

                                    // Maksimum 24 rakam (TR hariç)
                                    raw = raw.slice(0, 24);

                                    // TR ekle
                                    let formatted = "TR" + raw;

                                    // 4’lü gruplara böl
                                    formatted = formatted
                                      .match(/.{1,4}/g)
                                      ?.join(" ") || "";

                                    this.setState({ iban: formatted });
                                  }}
                                />
                                <div />
                              </div>
                            </div>
                            {/* IBAN Hata mesajının geleceği alan*/}
                            <div
                              className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                              id="iban_hatamesaj"
                            />

                          </div>

                        )}
                      </div>
                    )}


                    {/* Açıklama*/}
                    {(this.state.reason != "7") && (
                      <div className="col-12 pb-1">
                        <div>
                          <span className="t-icInputTitle pl-3">Açıklama</span>
                        </div>
                        <div className="col-12 p-0">
                          <div className="t-icInput">
                            <div>
                              <i className="t-icon-bubble1" />
                            </div>
                            <textarea
                              className="form-control"
                              id="mesaj"
                              name="mesaj"
                              rows="3"
                              required
                              maxLength="1000"
                              value={this.state.description}
                              onChange={(e) => {
                                this.setState({ description: e.target.value });
                              }}
                              placeholder="Mesajınızı Yazınız"

                            />
                            <div />
                          </div>
                        </div>
                        {/* Mesaj Hata mesajının geleceği alan*/}
                        <div
                          className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                          id="mesaj_hatamesaj"
                        />
                      </div>
                    )}



                    {/* checkbox */}
                    <div className="col-12 d-flex align-items-center pb-3">
                      <input
                        type="checkbox"
                        className="t-kvkkcheckbox"
                        value=""
                        id="onaychecked"
                      />
                      <span
                        className="t-icAciklamaYazi"
                        style={{ paddingLeft: 10, position: "relative" }}
                      >
                        <a id="kvkk-onayla" href="#kvkk-onayla" onClick={this.getKvkk}>KVKK Taahhütnamesi</a>'ni <strong>ONAYLIYORUM</strong>

                        <div className="t-tooltip">
                          <i className="t-icon-arrow-left pr-1" />
                          Devam Etmek İçin Onaylamalısınız
                        </div>
                      </span>
                    </div>
                    {/* Button */}
                    <div className="col-12 d-flex justify-content-center pb-3">
                      <button className="t-icButtonYesil" onClick={this.onSubmit}>
                        <span>Mesajımı Gönder</span>
                        <i className="t-icon-arrow-right2" />
                      </button>
                    </div>
                  </div>
                  {/* içerikler BİTTİ */}
                </div>
                <div className="col-auto renk" />
              </div>
              {/* KUTU 1 BİTTİ */}
            </div>
          </div>
          {/* Duyurlar Baslık*/}
          {/* duyrular Bitti*/}
          <div className="row" style={{ height: 30 }} />


          <KvkkModal
            isOpen={this.state.isKvkkModalOpen}
            kvkkMetni={this.state.kvkkMetni}
            onClose={this.closeKvkkModal}
          />

        </div>

      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    workflow: selectWorkflow(state),
    memberFekList: state.workflow.memberFek || [],
    memberIbanList: state.workflow.memberIban || [],
    isLoading: state.workflow.isLoading || false
  };
};

const mapDispatchToProps = (dispatch) => ({
  addFeedbacks: (subject, description, reason, memberNo, nameSuranme, tckn, fatherName, unvan, vkn, mersisNo, iban, phone) =>
    dispatch(addFeedbacks(subject, description, reason, memberNo, nameSuranme, tckn, fatherName, unvan, vkn, mersisNo, iban, phone)),
  getMemberFeks: (orgTuru) => dispatch(getMemberFeks(orgTuru)),
  getMemberIbans: () => dispatch(getMemberIbans()),
  clearMemberFek: () => dispatch(clearMemberFek()),
  clearMemberIban: () => dispatch(clearMemberIban())
});

export default connect(mapStateToProps, mapDispatchToProps)(SubmitDemand);
